

export default function PublicationsIcon({ className }) {
    return (
        <svg width="13" height="16" viewBox="0 0 13 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.625 0C1.19402 0 0.780698 0.168571 0.475951 0.468629C0.171205 0.768687 0 1.17565 0 1.6V14.4C0 14.8243 0.171205 15.2313 0.475951 15.5314C0.780698 15.8314 1.19402 16 1.625 16H11.375C11.806 16 12.2193 15.8314 12.524 15.5314C12.8288 15.2313 13 14.8243 13 14.4V4.8L8.125 0H1.625ZM1.625 1.6H7.3125V5.6H11.375V14.4H1.625V1.6ZM3.25 8V9.6H9.75V8H3.25ZM3.25 11.2V12.8H7.3125V11.2H3.25Z" fill={className} />
        </svg>

    )
}
